module.exports = __webpack_public_path__ + "static/media/tag.6a45837c.svg";